import { IConfig, ResourceInfo } from '../models/IConfig';
import {
  AutoSuggestDocument,
  JobTaxonomyType,
  JobTaxonomyV2Client,
  Role,
  RoleResponse,
  SearchClient,
  TaxonomicRank,
} from '../models/RoleLibrary.types';
import { BaseService } from './BaseService';
import { IPublicClientApplication } from '@azure/msal-browser';
export class RoleLibraryService extends BaseService {
  private readonly searchClient: SearchClient;
  private readonly JobTaxonomyV2Client: JobTaxonomyV2Client;
  public constructor(resourceInfo: ResourceInfo, msalInstance: IPublicClientApplication) {
    super(resourceInfo, msalInstance);
    const getAccessToken = this.getAccessToken.bind(this);
    const config: IConfig = {
      getAuthorization: getAccessToken,
      AdditionalHeaders: {
        'Ocp-APIM-Subscription-Key': __HR_APIM_SUBSCRIPTION_KEY__,
      },
    };

    this.searchClient = new SearchClient(config, resourceInfo.resourceBaseUrl);
    this.JobTaxonomyV2Client = new JobTaxonomyV2Client(config, resourceInfo.resourceBaseUrl);
  }

  public async getAutoSuggestedRoles(
    searchText: string,
    taxonomyTypeId: string | undefined
  ): Promise<AutoSuggestDocument[]> {
    return await this.searchClient.autoSuggestTaxonomicRankName(searchText, taxonomyTypeId);
  }

  public async getTaxonomyTypes(): Promise<JobTaxonomyType[]> {
    return await this.JobTaxonomyV2Client.getTaxonomyTypes();
  }

  public async getTaxonomicRank(taxonomyType: string, parentTaxonomyId?: string): Promise<TaxonomicRank[]> {
    return await this.JobTaxonomyV2Client.getTaxonomicRank(taxonomyType, parentTaxonomyId);
  }

  public async getRoleDetails(roleId: string): Promise<RoleResponse> {
    return await this.JobTaxonomyV2Client.getRoleDetails(roleId);
  }

  public async getTaxonomicRankById(taxonomyType: string, taxonomyId: string): Promise<TaxonomicRank> {
    return await this.JobTaxonomyV2Client.getTaxonomicRankById(taxonomyType, taxonomyId);
  }

  public async getCareerPath(roleId: string): Promise<Role[]> {
    return await this.JobTaxonomyV2Client.getCareerPath(roleId);
  }
}
